package com.wintermar.inspection.feature.data.remote.mapper.auth

import com.wintermar.inspection.feature.domain.model.auth.LoginModel
import com.wintermar.inspection.feature.domain.model.auth.UserModel
import com.wintermar.inspection.graphql.LoginMutation

fun LoginMutation.Login.toLoginModel(): LoginModel {
    return LoginModel(
        token = token ?: "",
        refreshToken = refreshToken ?: "",
        failedAttemptMessage = failedAttemptMessage ?: "",
        user = UserModel(
            userId = (userId ?: "").toString(),
            fullName = user?.fullName ?: "",
            listAccess = user?.accesses?.readWrite ?: listOf()
        ),
    )
}
